import type { ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

import type { CdmaResponse } from '@rtkwlf/syte-products';

type FrameworkContextType = {
  currentCdmaFramework: CdmaResponse | null;
  setCdmaFramework: (currentCdmaFramework: CdmaResponse | null) => void;
  frameworkList: CdmaResponse[];
  setFrameworkList: (frameworkList: CdmaResponse[]) => void;
};

export const FrameworkContext = createContext<FrameworkContextType | undefined>(
  undefined,
);

export const FrameworkProvider = ({ children }: { children: ReactNode }) => {
  const [currentCdmaFramework, setCdmaFramework] =
    useState<CdmaResponse | null>(null);
  const [frameworkList, setFrameworkList] = useState<CdmaResponse[]>([]);
  const value = useMemo(
    () => ({
      currentCdmaFramework,
      setCdmaFramework,
      frameworkList,
      setFrameworkList,
    }),
    [currentCdmaFramework, setCdmaFramework, frameworkList, setFrameworkList],
  );
  return (
    <FrameworkContext.Provider value={value}>
      {children}
    </FrameworkContext.Provider>
  );
};

export const useCdmaFrameworkContext = () => {
  const context = useContext(FrameworkContext);
  if (!context) {
    throw new Error('useFramework must be used within a FrameworkProvider');
  }
  return context;
};
